<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal modal-account-verification" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content" style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal">
                <span>
                  Change Email Address
                </span>
                            </p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg" alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content" style="overflow: visible">
                                <TextField
                                    v-model="password"
                                    name="password"
                                    label="Current Password"
                                    :type="isShowPassword ? 'text' : 'password'"
                                >
                                    <template #append-icon>
                                        <a @click.prevent="toggleShowPassword">
                                            <img v-if="!isShowPassword" src="~@/assets/images/Eye_Icon_lighter.svg"
                                                 alt="">
                                            <img v-else src="~@/assets/images/Eye_Icon_Splash.svg" alt="">
                                        </a>
                                    </template>
                                </TextField>
                                <div class="row">
                                    <div class="col-md-4 text-left">
                                        <SelectField
                                            v-model="country_code"
                                            name="country_code"
                                            rules="required"
                                            :options="countries"
                                            :has-icon="true"
                                            :has-shadow="true"
                                        >
                                            <template #append-icon>
                                                <a @click.prevent="() => {}">
                                                    <i
                                                        class="fa fa-chevron-circle-down mt-2"
                                                        style="font-size: 20px; color: #40b8dc"
                                                    />
                                                </a>
                                            </template>
                                        </SelectField>
                                    </div>
                                    <div class="col-md-8">
                                        <TextField
                                            v-model="new_phone"
                                            name="new_phone_num"
                                            label="Phone Number"
                                            :has-shadow="true"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-flex justify-content-center mt-5">
                                    <button v-text="'Next'"
                                            :disabled="!password || !new_phone"
                                            class="btn-dialog btn-sm ok-btn mr-2" @click="performChangePhone">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextField from "@/commons/FormElements/TextField.vue";
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";
import SelectField from "@/commons/FormElements/SelectField.vue";
import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";

export default {
    name: "ModalAccountChangePhone",
    components: {SelectField, TextField},
    props: {
        user_country_code: String
    },
    data() {
        return {
            password: '',
            new_phone: '',
            isShowPassword: false,
            country_code: '',
            countries: []
        };
    },
    created() {
        this.getCountry();
    },
    computed: {
        isOwner() {
            return this.$cookies.get("_user").is_owner;
        }
    },
    methods: {
        getCountry() {
            this.isLoadingData = true;
            DibbleJS.showLoader()
            DibbleJS.callApiRequest({
                '#request': DibbleAPI.api.getCountryCodes,
            }, (response) => {
                DibbleJS.hideLoader()
                if (DibbleAPI.isResponseSuccess(response)) {
                    this.countries = response.countries.map((item) => ({
                        value: item.country_code.toUpperCase(),
                        label: `+ ${item.dialing_code} (${item.name})`,
                        show_label: `+ ${item.dialing_code} (${item.country_code})`,
                    }));
                }

                this.country_code = this.user_country_code;
            })
        },
        toggleShowPassword() {
            this.isShowPassword = !this.isShowPassword;
        },
        performChangePhone() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.isOwner
                    ? DibbleApi.api.accountChangeFactor
                    : DibbleApi.api.managedUserChangeFactor,
                factor_type: 'PHONE',
                curr_password: this.password,
                new_phone_num: this.new_phone,
                new_country_code: this.country_code
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    const {is_verified} = responseData;
                    if (!is_verified) {
                        DibbleJs.toastSuccessMessage('Phone changed successfully');
                    } else {
                        this.$emit('emit-verification', responseData)
                    }
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.form-box.otp-input-wrap {
    box-shadow: 0px 12px 20px -16px #767676;
    /* -webkit-box-shadow: 0px 12px 20px -12px #767676; */
    -moz-box-shadow: -1px 7px 5px -2px rgba(191, 191, 191, 0.75);
    background: #e8eff1;
    padding-top: 14px;
}

.otp-input {
    width: 30px;
    height: 30px;
    border-radius: 5px;
    text-align: center;
    font-size: 25px;
    font-weight: 600;
}
</style>
